import { workflowSteps } from '@/mocks/homeData';

export default function WorkflowSteps() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Basetao Shopping Workflow
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            Four simple steps to a smarter, more organized shopping experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {workflowSteps.map((step) => (
            <div key={step.step} className="relative text-center group">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors duration-200">
                <span className="text-xl md:text-2xl font-heading font-bold text-primary-600">
                  {step.step}
                </span>
              </div>
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center">
                <i className={`${step.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}